import { render } from "./InAppLink.vue?vue&type=template&id=53d22a12&ts=true"
import script from "./InAppLink.vue?vue&type=script&lang=ts"
export * from "./InAppLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__